/**
 * Created by chenli
 */
import Component from "../../../../../../lib/component";
import template from './expert-search-left-menu.html';
import './expert-search-left-menu.scss';

let expertLeftMenu = Component.extend({
    template: template,
    data: {
        choosed: [],
        chooseCurrent:[]
    },
    binds: [
    ],
    actions: {
        /**
         * 初始化已选中的复选框
         */
        renderChoosed: function () {
            if (this.data.choosed.length) {
                this.actions.loadSelect();
            }
        },
        loadSelect:function () {
            this.data.choosed.forEach((item) => {
                if (!_.isUndefined(item.id)) {
                    let checkbox = this.el.find(`input:checkbox[data-id="${item.id}"]`);
                    if (checkbox.length && item.checked) {
                        checkbox[0].checked = true;
                    }
                }
            });
        },
        /**
         * 选取当前item
         * @param item
         */
        selectItem: function(context) {
            let checked = $(context)[0].target.checked;
            let id = $(context.target).parent().parent().parent()[0].dataset.id;
            this.actions.calTitleArray(context);
            this.data.choosed.forEach((item)=>{
                if(item.id === id ) {
                    item.checked = checked;
                    this.data.chooseCurrent = item;
                }
            })
            this.actions.renderChoosed();
        },
        /**
         * 拼接choosed 数据
         * @param item
         */
        calTitleArray(item){
            let id = $(item.target).parent().parent().parent()[0].dataset.id;
            let name = $(item.target).parent().parent().parent()[0].dataset.name;
            let checked = $(item)[0].target.checked;
            let choosedId  = []
            this.data.choosed.forEach((item)=>{
                if(choosedId.indexOf(item.id) === -1) {
                    choosedId.push(item.id)
                }
            })
            if ($(item)[0].target.checked && !choosedId.includes(id)) {
                let choosed = {
                    id: id,
                    name: name,
                    checked:checked
                };
                this.data.choosed.push(choosed);
            }
        },
    },
    firstAfterRender: function () {
        /**
         * 渲染常用查询
         * @param this.data.choosed
         */
        this.data.choosed.forEach((item,index)=> {
            this.events.checkedQuery(this.data.choosed[index]);
        })
    },
    afterRender: function() {
        /**
         * 点击选中/取消选中菜单事件
         */
        this.el.find('input[type=checkbox]').on('click',(e)=>{
            this.actions.selectItem(e);
            this.events.checkedQuery(this.data.chooseCurrent);
        })
        /**
         * 搜索列名称
         */
        this.el.find('.result').on('input',(e)=>{
            let val = e.target.value;
            let lis = $(e.target).parent().next().find('li');
            for(let li of lis){
                li.style.display = val == '' || li.innerHTML.indexOf(val)!=-1 ? 'block' : 'none';
            }
        })
        this.actions.renderChoosed();
    }
})
export default expertLeftMenu


// WEBPACK FOOTER //
// app/components/dataGrid/data-table-toolbar/expert-search/expert-search-condition-simple/expert-search-left-menu/expert-search-left-menu.js